module.exports = __webpack_public_path__ + "static/img/grayImage.b251766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grayImage.jpg
// module id = fCTC
// module chunks = 26